// Site information
export const SITE_CONFIG = {
  name: 'Cy Art Luthier',
  title: 'Cy Art Luthier | Fabrication Réparation Guitare Basse | Le Crès',
  description: 'Fabrication artisanale de guitares et basses sur-mesure. Réparation, formation et recyclage d\'instruments à Le Crès, près de Montpellier.',
  url: 'https://cy-art-luthier.fr',
  ogImage: '/og-image.jpg',
}

// Contact information
export const CONTACT_INFO = {
  name: 'Julien Barat',
  businessName: 'Cy Art Luthier',
  siret: '91952372000010',
  address: {
    street: '3 Rue des Aiguerelles',
    city: 'Le Crès',
    postalCode: '34920',
    full: '3 Rue des Aiguerelles, 34920 Le Crès',
  },
  phone: '07 83 92 41 07',
  phoneLink: 'tel:+33783924107',
  email: 'cyartluthier@gmail.com',
  emailLink: 'mailto:cyartluthier@gmail.com',
  nearCities: ['Montpellier', 'Castelnau-le-Lez', 'Teyran', 'Vendargues', 'Jacou', 'Clapiers', 'Mauguio'],
}

// Opening hours
export const OPENING_HOURS = [
  { day: 'Lundi', morning: 'Fermé', afternoon: 'Fermé' },
  { day: 'Mardi', morning: 'Sur RDV (9h30-12h30)', afternoon: 'Ouvert (13h30-18h)' },
  { day: 'Mercredi', morning: 'Sur RDV (9h30-12h30)', afternoon: 'Ouvert (13h30-18h)' },
  { day: 'Jeudi', morning: 'Sur RDV (9h30-12h30)', afternoon: 'Ouvert (13h30-18h)' },
  { day: 'Vendredi', morning: 'Sur RDV (9h30-12h30)', afternoon: 'Ouvert (13h30-18h)' },
  { day: 'Samedi', morning: 'Ouvert (9h30-13h)', afternoon: 'Fermé' },
  { day: 'Dimanche', morning: 'Fermé', afternoon: 'Fermé' },
]

// Social media links
export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/cy_art_luthier/',
  facebook: 'https://www.facebook.com/CyArtLuthier/',
  youtube: 'https://www.youtube.com/@CyArtLuthier',
  whatsapp: 'https://wa.me/33783924107',
}

// Google Maps
export const GOOGLE_MAPS = {
  embedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2889.7!2d3.9!3d43.65!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sCy%20Art%20Luthier!5e0!3m2!1sfr!2sfr!4v1700000000000!5m2!1sfr!2sfr',
  link: 'https://maps.google.com/?q=Cy+Art+Luthier+Le+Cres',
}

// Navigation links
export const NAV_LINKS = [
  { name: 'Accueil', href: '/' },
  { name: 'Mes Créations', href: '/mescreations' },
  { name: 'Services', href: '/services' },
  { name: 'À propos', href: '/a-propos' },
]

// Instrument types
export const INSTRUMENT_TYPES = [
  { id: 'all', label: 'Tout', value: 'all' },
  { id: 'electric', label: 'Électrique', value: 'electric' },
  { id: 'acoustic', label: 'Acoustique', value: 'acoustic' },
  { id: 'bass', label: 'Basse', value: 'bass' },
] as const

// Contact form subjects
export const CONTACT_SUBJECTS = [
  { value: 'devis', label: 'Demande de devis' },
  { value: 'repair', label: 'Réparation' },
  { value: 'training', label: 'Formation / Stage' },
  { value: 'other', label: 'Autre' },
] as const

// Budget ranges for devis
export const BUDGET_RANGES = [
  { value: 'under-1000', label: 'Moins de 1 000 €' },
  { value: '1000-2000', label: '1 000 € - 2 000 €' },
  { value: '2000-5000', label: '2 000 € - 5 000 €' },
  { value: 'over-5000', label: 'Plus de 5 000 €' },
  { value: 'to-discuss', label: 'À discuter' },
] as const

// Appointment types
export const APPOINTMENT_TYPES = [
  { value: 'consultation', label: 'Consultation sur-mesure', duration: '1h' },
  { value: 'repair', label: 'Réparation / Diagnostic', duration: '30min' },
  { value: 'visit', label: 'Visite atelier', duration: '45min' },
  { value: 'training', label: 'Formation / Stage', duration: 'À préciser' },
] as const

// Skill levels for formations
export const SKILL_LEVELS = [
  { value: 'beginner', label: 'Débutant' },
  { value: 'intermediate', label: 'Intermédiaire' },
  { value: 'advanced', label: 'Avancé' },
] as const

// Site pages pour ticketing
export const SITE_PAGES = [
  { name: 'Accueil', path: '/', label: 'page:accueil' },
  { name: 'Mes Créations', path: '/mescreations', label: 'page:creations' },
  { name: 'Services', path: '/services', label: 'page:services' },
  { name: 'À propos', path: '/a-propos', label: 'page:about' },
  { name: 'Contact', path: '/contact', label: 'page:contact' },
  { name: 'Dashboard', path: '/dashboard', label: 'page:dashboard' },
  { name: 'Autre / Général', path: null, label: null },
] as const

// Issue types pour ticketing
export const ISSUE_TYPES = [
  { value: 'bug', label: '🐛 Bug / Problème', color: 'red' },
  { value: 'enhancement', label: '✨ Amélioration', color: 'blue' },
] as const
